import { useEffect, useState } from "react";
import Loader from "../../../../../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import ShipperDetailsTable from "../../../../../components/ShipperDetailTable/ShipperDetailTable";
import {
  getSiteReturnDataService,
  submitReturnDataService,
} from "../../../../../services/siteManagamentService";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../../../utilities/helper";
import SiteReturnDepotConfirmPage from "./SiteReturnDepotConfirmPage/SiteReturnDepotConfirmPage";

const SiteReturnDepot = () => {
  const id = useLocation()?.state?.id;
  const siteName = useLocation()?.state?.name;

  const access_token = localStorage.getItem("access_token");
  const userId = localStorage.getItem("roleId");
  const currentUserCultureCode = localStorage?.getItem(
    "currentUserCultureCode"
  );

  const [load, setLoad] = useState(false);
  const [siteReturnData, setSiteReturnData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [showConfirmationPage, setShowConfirmationPage] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (id && currentUserCultureCode) {
      getOnLoadSiteReturnData(id);
    }
  }, [id]);

  const handleDrugReturnData = (data) => {
    let nonNullData = Object.keys(data)?.filter((key) => data[key] !== null);

    const tempData = siteReturnData
      .filter((item) => nonNullData?.includes(String(item.drugId)))
      .map((item) => ({
        id: item.drugId,
        drugKitNumber: item.drugKitNumber,
        status: data[item.drugId],
      }));

    setUpdatedData(tempData);
  };

  const getOnLoadSiteReturnData = async (siteId) => {
    try {
      setLoad(true);
      const res = await getSiteReturnDataService(
        access_token,
        siteId,
        currentUserCultureCode
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "Onload data extracted!"
      ) {
        const data =
          res?.data?.result?.drugReturnConfiguration?.patientVisitDrugs?.map(
            (item) => ({
              drugId: item?.id,
              drugId_new: item?.drugId,
              statusText: item?.drug?.statusText,
              packingType: item?.drug?.packageName,
              patientVisitId: item?.patientVisitId,
              drugStatusTypeId: item?.drugStatusTypeId,
              drugKitNumber: item?.drug?.drugKitNumber,
            })
          );
        setSiteReturnData(data);
        setStatusData(
          res?.data?.result?.drugReturnConfiguration?.drugStatusTypes
        );
      }
    } catch (err) {
      console.log("Error: ", err?.message);
    } finally {
      setLoad(false);
    }
  };

  const submitData = async () => {
    try {
      setLoad(true);

      const reconciledDrugList = siteReturnData
        ?.filter((rec) => updatedData.some((upd) => upd.id === rec.drugId))
        ?.map((rec) => {
          const matched = updatedData.find((upd) => upd.id === rec.drugId);
          return {
            id: rec?.drugId,
            drugId: rec?.drugId_new,
            patientVisitId: rec?.patientVisitId,
            drugKitNumber: rec?.drugKitNumber,
            drugStatusTypeId: rec?.drugStatusTypeId,
            changedDrugStatusTypeId: matched?.status,
            isChangedDrugStatusType: true,
          };
        });

      const payload = {
        siteId: id,
        reconciledDrugList: reconciledDrugList,
      };

      const res = await submitReturnDataService(access_token, payload, userId);

      if (
        res?.status == 200 &&
        res?.data?.message === "Placed Order for these SiteReturnKits! "
      ) {
        notifySuccess(res?.data?.message);
        setShowConfirmationPage(true);
        setConfirmationData(res?.data?.result?.kitsData);
      } else if (
        res?.status === 200 &&
        res?.data?.message === "No available drug kits to update"
      ) {
        notifyWarning("Please Select Atleast One Kit to Proceed !");
      }
    } catch (err) {
      console.log("Error : ", err?.message);
      notifyError(err?.data?.message);
      if (err?.status === 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {showConfirmationPage ? (
        <SiteReturnDepotConfirmPage
          data={confirmationData}
          setShowConfirm={setShowConfirmationPage}
          siteId={id}
          siteName={siteName}
        />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => navigate("/")}
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => navigate("/site-management")}
                >
                  Site Management
                </button>{" "}
                |
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    navigate("/addUpdate-site-management", {
                      state: { id: id },
                    })
                  }
                >
                  {siteName || "Site Details"}
                </button>
                |{" "}
                <button className="bread-crumbs-btn">
                  Site Return To Depot
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>

              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={4}>
                  <p className="page-heading">Site Return To Depot</p>
                </Grid2>
              </Grid2>

              <div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    margin: "2px auto",
                    textAlign: "start",
                  }}
                >
                  Kit Status Updates{" "}
                  <span
                    style={{
                      color: "gray",
                    }}
                  >
                    {siteName}
                  </span>
                </div>
              </div>

              {siteReturnData && siteReturnData?.length > 0 ? (
                <div
                  style={
                    {
                      // maxHeight: "1200px",
                      // overflowY: "auto",
                      // width: "100%",
                      // marginTop: "20px",
                    }
                  }
                >
                  <ShipperDetailsTable
                    actions={statusData}
                    data={siteReturnData}
                    isReset={false}
                    onChange={handleDrugReturnData}
                    isCustomColumn={true}
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    border: "1px solid lightgrey",
                    marginTop: "20px",
                    borderRadius: "5px",
                  }}
                >
                  <h3
                    style={{
                      color: "gray",
                    }}
                  >
                    No Data Available
                  </h3>
                </div>
              )}

              <Grid2
                alignItems={"end"}
                justifyContent="end"
                container
                gap={3}
                sx={{ marginTop: "2%" }}
              >
                <Grid2 item md={6}>
                  <button
                    onClick={submitData}
                    className={
                      siteReturnData?.length === 0
                        ? "disabled-btn"
                        : "create-btn"
                    }
                  >
                    Save
                  </button>
                </Grid2>
              </Grid2>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SiteReturnDepot;
